var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.203506 10.5583C0.203506 6.52996 0.203506 4.51578 1.16343 3.06503C1.59208 2.4172 2.14689 1.86239 2.79472 1.43374C4.24547 0.473816 6.25965 0.473816 10.288 0.473816C14.3164 0.473816 16.3305 0.473816 17.7813 1.43374C18.4291 1.86239 18.9839 2.4172 19.4126 3.06503C20.3725 4.51578 20.3725 6.52996 20.3725 10.5583C20.3725 14.5867 20.3725 16.6008 19.4126 18.0516C18.9839 18.6994 18.4291 19.2542 17.7813 19.6829C16.3305 20.6428 14.3164 20.6428 10.288 20.6428C6.25965 20.6428 4.24547 20.6428 2.79472 19.6829C2.14689 19.2542 1.59208 18.6994 1.16343 18.0516C0.203506 16.6008 0.203506 14.5867 0.203506 10.5583ZM15.5087 10.5586C15.5087 13.442 13.1712 15.7794 10.2878 15.7794C7.40442 15.7794 5.06696 13.442 5.06696 10.5586C5.06696 7.67516 7.40442 5.3377 10.2878 5.3377C13.1712 5.3377 15.5087 7.67516 15.5087 10.5586ZM10.2878 14.0131C12.1957 14.0131 13.7423 12.4664 13.7423 10.5586C13.7423 8.6507 12.1957 7.10406 10.2878 7.10406C8.37995 7.10406 6.83332 8.6507 6.83332 10.5586C6.83332 12.4664 8.37995 14.0131 10.2878 14.0131ZM15.7149 6.30215C16.3924 6.30215 16.9416 5.75292 16.9416 5.0754C16.9416 4.39789 16.3924 3.84865 15.7149 3.84865C15.0374 3.84865 14.4881 4.39789 14.4881 5.0754C14.4881 5.75292 15.0374 6.30215 15.7149 6.30215Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7b974fb93874aabbfd0f24fdb315ada1.svg";
export { ForwardRef as ReactComponent };